import React from 'react';

const LABELS = {
  sent: 'Issued',
};

export default function StatusPill({ status, onClick }) {
  const s = (status || '').toLowerCase().replace(/[^a-z_]/g, '');
  const label = LABELS[s] || status;
  return (
    <span
      className={'pill pill-' + s.replace(/_/g, '')}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >{label}</span>
  );
}
